<ngx-slick-carousel class="carousel" [config]="slideConfig" #slickModal="slick-carousel">
  @for (genre of popularGenres; track genre) {
    <div ngxSlickItem class="slide">
      <bmcore-genre-category [genre]="genre"></bmcore-genre-category>
    </div>
  }
</ngx-slick-carousel>
